import React from 'react';

export default {
  Layout: (props) => (
    <div style={{ height: '100%' }}>{props.children}</div>
  ),

}